import { gql } from '@apollo/client';

export const DOMAIN_EMPLOYEES_QUERY = gql`
  query DomainEmployees {
    domainEmployees {
      id
      email
      username
      role
    }
  }
`;

export const CREATE_EMPLOYEE_MUTATION = gql`
  mutation CreateEmployee($email: String!, $password: String!, $username: String!, $role: String!) {
    createEmployee(email: $email, password: $password, username: $username, role: $role) {
      employee {
        id
        email
        username
        role
      }
    }
  }
`;
